export default __webpack_public_path__ + "static/testimonial1-c4723237dedd56a4523014564314542a.png";